module.exports = __webpack_public_path__ + "static/media/shop_getty_desktop.ccb87e09.jpg";